import React from 'react';
import PropTypes from 'prop-types';
import { FullPetDetailsPropTypes, PolicyDetailsPropTypes } from '../../../propTypes/petDetails';
import { PetIcon } from '../../petIcon/petIcon';
import { NoDocuments } from '../noDocuments/noDocuments';
import { DocumentTypeKeys } from '../../../propTypes/documents';
import { useDownloadDocumentMutation } from '../../../data/document';
import { downloadPdfFile } from '../../../helpers/docHelpers';
import './petPolicyDocumentsPanel.scss';
import { getGtmService } from '../../../services/gtmService/GtmService';
import { DOCUMENT_TYPE } from '../../../services/gtmService/consts';
import { legacyPolicyNumberHandler } from '../../../helpers/paymentHelper';

export const PetPolicyDocumentsPanel = ({
  petDetail,
  policyDetails,
  keyedPetDocuments,
  docType,
  layout = 'panel',
  auth0Token
}) => {
  const { PolicyNumber, FullPolicyNumber, Name, Species, PetProfilePicture } = petDetail;
  const [downloadDocument] = useDownloadDocumentMutation();

  const { PetGender } = policyDetails;

  const petDocuments = keyedPetDocuments[PolicyNumber];

  if (!petDocuments) {
    return null;
  }

  const handlePetDocumentLink = async ({ petDocument }) => {
    const gtm = getGtmService();

    if (petDocument.fileExtension !== null) {
      const { attachmentId } = petDocument;
      try {
        await downloadPdfFile(
          downloadDocument,
          { policyNumber: legacyPolicyNumberHandler(PolicyNumber), attachmentId, auth0Token },
          attachmentId.toString()
        );

        gtm.pushDocumentDownload(DOCUMENT_TYPE.COI, FullPolicyNumber);
      } catch (error) {
        throw new Error(error);
      }
    } else {
      const { storagePointer } = petDocument;
      window.open(storagePointer, '_blank');

      const docType = petDocument?.description === DOCUMENT_TYPE.PDS ? DOCUMENT_TYPE.PDS : DOCUMENT_TYPE.OTHER;
      gtm.pushDocumentDownload(docType, FullPolicyNumber);
    }
  };

  return (
    <section className={`petDocumentsPanel petDocumentsPanel_${layout}`}>
      <div className="petLabel">
        <PetIcon
          profilePic={PetProfilePicture}
          fullPolicyNumber={FullPolicyNumber}
          gender={PetGender}
          species={Species}
        />
        <span className="petDetails">
          <strong>{Name}</strong>
        </span>
      </div>
      <div className="petDocuments">
        {petDocuments[docType] &&
          petDocuments[docType].map((petDocument) => (
            <button
              key={petDocument.attachmentNumber}
              className="button primary outline"
              onClick={() => handlePetDocumentLink({ petDocument })}
              type="button"
            >
              <span className="labelText">{petDocument.description}</span>
            </button>
          ))}

        {!petDocuments[docType] && <NoDocuments docType={docType} />}
      </div>
    </section>
  );
};

PetPolicyDocumentsPanel.propTypes = {
  petDetail: FullPetDetailsPropTypes,
  policyDetails: PolicyDetailsPropTypes,
  // eslint-disable-next-line react/forbid-prop-types
  keyedPetDocuments: PropTypes.any,
  docType: PropTypes.oneOf(DocumentTypeKeys),
  layout: PropTypes.oneOf(['panel', 'table']),
  auth0Token: PropTypes.string
};
